import script from "./PlusSVG.vue?vue&type=script&setup=true&lang=js"
export * from "./PlusSVG.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__